'use strict';
document.querySelector('.btn__ancre').addEventListener('click', function(e) {
    e.preventDefault(); 
    
    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);
    
    if(targetElement) {
        targetElement.scrollIntoView({
            behavior: 'smooth', 
            block: 'start'   
        });
    }
});
